import { IoCheckmarkCircle, IoCloseCircle, IoHourglass } from "react-icons/io5";

const SaveIndicator = ({ saveStatus }) => {
  if (!saveStatus) return <div className="w-2 h-2" />;

  const getIcon = () => {
    switch (saveStatus) {
      case "loading":
        return (
          <IoHourglass
            className="w-2 h-2 text-blue-500 animate-spin"
            data-testid="save-indicator-loading"
          />
        );
      case "success":
        return (
          <IoCheckmarkCircle
            className="w-2 h-2 text-green-500"
            data-testid="save-indicator-success"
          />
        );
      case "error":
        return (
          <IoCloseCircle
            className="w-2 h-2 text-red-500"
            data-testid="save-indicator-error"
          />
        );
      default:
        return <div className="w-2 h-2" data-testid="save-indicator-default" />;
    }
  };

  return getIcon();
};

export default SaveIndicator;
